import { Box } from '@mui/material';
import pendingRequestsStyle from '../../Styles/ComponentStyles/PendingRequests/PendingRequests.module.scss';
import { PendingRequestsTableTooltip } from './PendingRequestsTableTooltip';

const MAX_REJECT_REASON_WORDS = 6;

function truncateRejectReason(text: string, maxWords: number): { display: string; isTruncated: boolean } {
    const trimmed = (text ?? '').trim();
    if (!trimmed || trimmed === '—') {
        return { display: trimmed || '—', isTruncated: false };
    }
    const words = trimmed.split(/\s+/);
    if (words.length <= maxWords) {
        return { display: trimmed, isTruncated: false };
    }
    return { display: `${words.slice(0, maxWords).join(' ')}...`, isTruncated: true };
}

interface RejectedReasonCellProps {
    reason: string;
}

export function RejectedReasonCell({ reason }: RejectedReasonCellProps) {
    const { display, isTruncated } = truncateRejectReason(reason, MAX_REJECT_REASON_WORDS);
    const fullText = (reason ?? '').trim();

    const content = (
        <Box className={pendingRequestsStyle.overflowTooltipCell}>
            <span className={pendingRequestsStyle.overflowTooltipText}>{display}</span>
        </Box>
    );

    return (
        <PendingRequestsTableTooltip
            title={fullText}
            subtitle="Rejection reason"
            disable={!isTruncated}
        >
            {content}
        </PendingRequestsTableTooltip>
    );
}
